import React from "react";
import { css } from "@emotion/css";
import { Modal, Button } from "semantic-ui-react";
import "../../styles/modal.scss";
import BCLoader from "./BCLoader";

const BCModal = ({ ...props }) => {
  const modalHeaderOverrideCSS = css`
    border-bottom: 2px solid ${props.brokerColor ? props.brokerColor : "black"}!important;
  `;

  return (
    <Modal
      className={props.className ? props.className : "bc-modal"}
      closeOnDimmerClick={!props.closeOnlyByButton}
      onClose={props.onClose}
      onOpen={props.onOpen}
      open={props.isModalOpen}
      size={props.size && props.size}
      closeIcon={!!props.closeIcon}
    >
      {props.header && <Modal.Header className={`modal-header ${props.headerClass && props.headerClass} ${props.brokerColor ? modalHeaderOverrideCSS : ""}`}>
        {props.header}
        {props.subHeader && <p className="modal-subheader">{props.subHeader}</p>}
      </Modal.Header>}
      <Modal.Content className={props.contentClass && props.contentClass}>
        {props.isLoading && <BCLoader height={200} />}
        {!props.isLoading && <>{props.children ? props.children : props.content}</>}
      </Modal.Content>
      {props.actions || props.buttonText && <Modal.Actions className={`modal-actions ${props.actionsClass && props.actionsClass}`}>
        {props.actions && props.actions}
        {!props.actions && props.buttonText && (
          <Button color="blue" onClick={props.onClose}>
            {props.buttonText}
          </Button>
        )}
      </Modal.Actions>}
    </Modal>
  );
};

export default BCModal;